/**
 * Gotcha 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {GOTCHA_QUERY_KEY_MAP} from '../api/gotcha/constant';
import {gotchaFactory} from '../factory/gotchaFactory';

// ============================================
// useGotchaQuery
// ============================================

export function useGotchaQuery(
  ...args: Parameters<typeof gotchaFactory.gotcha>
) {
  return useQuery(gotchaFactory.gotcha(...args));
}

useGotchaQuery.getKey = (
  ...args: Parameters<typeof GOTCHA_QUERY_KEY_MAP.gotcha>
) => [...GOTCHA_QUERY_KEY_MAP.gotcha(...args)];
